import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { equationStringToSimplifiedParsedString } from '~/bootcamp/Activities/Algebra/Algebra.utils'

const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['a', 'b', 'c', 'd', 'y', 'z'],
    maxHistoryLength: 10,
    answerType: 'positive',
  },
  2: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['a', 'b', 'c', 'd', 'y', 'z'],
    maxHistoryLength: 10,
    answerType: 'negative',
  },
  3: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['ab', 'by', 'cz', 'az', 'bc', 'cy', 'yz'],
    maxHistoryLength: 10,
    answerType: 'positive',
  },
  4: {
    minTerms: 2,
    maxTerms: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    variables: ['ab', 'by', 'cz', 'az', 'bc', 'cy', 'yz'],
    maxHistoryLength: 10,
    answerType: 'negative',
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  minCoefficient: number
  maxCoefficient: number
  variables: string[]
  maxHistoryLength: number
  answerType: 'positive' | 'negative'
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ActivityDataModel {
  coefficientString: string
  equationCoefficients: number[]
  variable: string
  coefficientTotal: number
  maxHistoryLength: number
}

/**
 * generates data related to activity
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns activity data
 */
export function generateVariableSubActivityData(difficultyLevel: number, taskHistory: string[]): ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const equationCoefficients: number[] = [getRandomInt(range.maxCoefficient - 1, range.maxCoefficient)]
  const variable = range.variables[getRandomInt(0, range.variables.length - 1)]
  let coefficientTotal = equationCoefficients[0]
  if (range.answerType === 'positive') {
    let _coefficient = 0
    // eslint-disable-next-line
    while (coefficientTotal > 0) {
      _coefficient = getRandomInt(range.minCoefficient, equationCoefficients[0] - 1)
      equationCoefficients[equationCoefficients.length] = _coefficient
      coefficientTotal -= _coefficient
    }
    // eslint-disable-next-line
    equationCoefficients.pop()
    coefficientTotal += _coefficient
  } else {
    let _coefficient = 0
    // eslint-disable-next-line
    while (coefficientTotal >= 0) {
      _coefficient = getRandomInt(range.minCoefficient, equationCoefficients[0])
      equationCoefficients[equationCoefficients.length] = _coefficient
      coefficientTotal -= _coefficient
    }
  }

  let coefficientString = variable
  equationCoefficients.forEach((item) => {
    coefficientString += `-${item}`
  })

  if (taskHistory.includes(coefficientString)) return generateVariableSubActivityData(difficultyLevel, taskHistory)

  return {
    coefficientString,
    equationCoefficients,
    variable,
    coefficientTotal,
    maxHistoryLength: range.maxHistoryLength,
  }
}

/**
 * checks the answer
 * @param answer user given answer
 * @param coefficientTotal expected coefficient
 * @param variable expected variable
 * @returns if the answer is right
 */
export function checkVariableSubAnswer(answer: string, coefficientTotal: number, variable: string): boolean {
  return (
    equationStringToSimplifiedParsedString(coefficientTotal + variable) ===
    equationStringToSimplifiedParsedString(answer)
  )
}
